<div class="top-bar-div">
  <a
    [routerLink]="loggedIn ? ['cookbook'] : ['']"
    (click)="clearCaches()"
    class="logo-image-div"
    ><div class="logo-link">
      <img
        ngSrc="../../../assets/home-page-images/logo-part1.webp"
        width="170"
        height="47"
        class="default-img"
        priority
        alt="Recimate Logo"
      />
      <img
        ngSrc="../../../assets/home-page-images/logo-part2.webp"
        width="170"
        height="47"
        class="hover-img"
        alt="Recimate :O"
      /></div
  ></a>
  <div class="master-hamburger-div">
    <top-bar-hamburger
      [logginButtonText]="logginButtonText"
      (logOutEmitter)="logout()"
      [showManagements]="showManagements()"
      (createNew)="createNew()"
      [loggedIn]="loggedIn"
    ></top-bar-hamburger>
  </div>

  <div class="button-div">
    @if (showManagements()) {
      <a [routerLink]="['/feedback']"><button class="top-bar-button">Feedback</button></a>
    }
    @if (showManagements()) {
      <a [routerLink]="['/reports-management']"><button class="top-bar-button">Reports</button></a>
    }
    @if (showManagements()) {
      <a [routerLink]="['/ingredient-management']"
        ><button class="top-bar-button">Ingredients</button></a
      >
    }
    @if (!loggedIn) {
      <a [routerLink]="['/about']"><button class="top-bar-button">About Us</button></a>
    }
    @if (loggedIn) {
      <a (click)="createNew()"><button class="top-bar-button">Create</button></a>
    }
    @if (loggedIn) {
      <a [routerLink]="['plan']"><button class="top-bar-button">Plan</button></a>
    }
    @if (loggedIn) {
      <a [routerLink]="['cookbook']"><button class="top-bar-button">Recipes</button></a>
    }

    @if (loggedIn) {
      <a [routerLink]="['settings']"><button class="top-bar-button">Settings</button></a>
    }
    <button
      class="top-bar-button"
      (click)="logout()"
    >
      {{ logginButtonText }}
    </button>
  </div>
</div>
